import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormMasterModule } from '../form-master/form-master.module';
import { SharedModule } from '../shared/shared.module';
import { AuthForwardGuard } from './auth-forward.guard';
import { AuthRoutes } from './auth.routes';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';

const internalComponents = [LoginComponent];
const exportableComponents = [LogoutComponent];

@NgModule({
  imports: [CommonModule, SharedModule, FormMasterModule, AuthRoutes],
  declarations: [...internalComponents, ...exportableComponents],
  exports: [...exportableComponents],
  providers: [AuthForwardGuard],
})
export class AuthModule {}
